import config from '@/config';
import { usePageTitleStore } from '@/store';

export const usePageTitle = () => {
  return {
    getTitle,
    setTitle,
  };
};

const getTitle = () => {
  return usePageTitleStore().pageTitle;
};

const appName = config.env === 'staging' ? 'SportPix (staging)' : 'SportPix';

const setTitle = title => {
  title = title ? `${title} | ${appName}` : appName;

  usePageTitleStore().$patch({ pageTitle: title });
};
